import Axios from "axios";
import { ApiResultModel } from "../models/common.model";
import {
  EditWalletTypeOfAStoreRequest,
  GetTransactionsRequest,
  GetTransactionsResponse,
  GetWalletTypesResponse,
} from "../models/wallet.model";
import { ApiBaseUrl, WalletUrl } from "../config/config";

export const getWalletTypes = (): Promise<ApiResultModel<
  GetWalletTypesResponse[]
>> => {
  return Axios.post<ApiResultModel<GetWalletTypesResponse[]>>(
    ApiBaseUrl + WalletUrl + "/GetWalletTypes"
  ).then((result) => {
    return result.data;
  });
};
export const editWalletTypeOfAStore = (
  data: EditWalletTypeOfAStoreRequest
): Promise<ApiResultModel<boolean>> => {
  return Axios.post<ApiResultModel<boolean>>(
    ApiBaseUrl + WalletUrl + "/EditWalletTypeOfAStore",
    data
  ).then((result) => {
    return result.data;
  });
};

export const GetTransactions = (
  data: GetTransactionsRequest
): Promise<GetTransactionsResponse[]> => {
  return Axios.get<ApiResultModel<GetTransactionsResponse[]>>(
    ApiBaseUrl +
      WalletUrl +
      "/GetTransactions/" +
      data.walletId +
      "/" +
      data.customerPersonId
  ).then((result) => {
    return result.data.data;
  });
};
